import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../Components/NavBar/NavBar";
import {
    Container,
    Row,
    Col,
    Card,
    Button,
    Form,
} from 'react-bootstrap';
import Footer from "../Components/Footer/Footer";
import Select from 'react-select';
import { Link } from "react-router-dom";
import axios from 'axios';
import TestimonialSection from "../Components/Shared/Testimonials";
// import { toast, ToastContainer } from 'react-toastify';

const ITEMS_PER_PAGE = 8;

const categoryOptions = [
    { value: 'Smartphones', label: 'Smartphones' },
    { value: 'Laptops', label: 'Laptops' },
    { value: 'Accessories', label: 'Accessories' },
    { value: 'all', label: 'All' },
];

const priceOptions = [
    { value: 'low', label: 'Price: Low to High' },
    { value: 'high', label: 'Price: High to Low' },
];

const Product = () => {
    const defaultCategory = categoryOptions.find(opt => opt.value === 'all') || categoryOptions[0];
    const [selectedCategory, setSelectedCategory] = useState(defaultCategory);
    const [priceOrder, setPriceOrder] = useState(priceOptions[0]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        async function fetchProducts() {
            setLoading(true);
            const res = await axios.get("https://www.azzenterprises.com/api/products");
            setProducts(res.data);
            setLoading(false);
        }
        fetchProducts();
    }, []);

    const filtered = useMemo(() => {
        let result = [...products];

        if (selectedCategory && selectedCategory.value !== 'all') {
            result = result.filter(p => p.category === selectedCategory.value);
        }

        if (searchTerm.trim()) {
            result = result.filter(p =>
                p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (priceOrder) {
            result.sort((a, b) =>
                priceOrder.value === 'low' ? a.sales_price - b.sales_price : b.sales_price - a.sales_price
            );
        }

        return result;
    }, [products, selectedCategory, priceOrder, searchTerm]);

    const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const paginated = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const goToPage = (n) => {
        if (n >= 1 && n <= totalPages) setCurrentPage(n);
    };

    return (
        <div>
            <Helmet>
                <title>Products</title>
            </Helmet>
            {/* <ToastContainer position="top-right" autoClose={5000} /> */}
            <NavBar />
            <main>
                <section className="bg-light py-md-5">
                    <Container>
                        <div className="bg-light py-5 text-center">
                            <h2 className="text-3xl fw-bold mb-3">
                                <span className="text-primary">EMI-Friendly</span> Laptops, Made Easy
                            </h2>
                            <p className="text-muted fs-5 mx-auto mb-4" style={{ maxWidth: '860px' }}>
                                Explore powerful laptops with flexible EMI options and exclusive pricing.
                            </p>

                            <div>
                                <Button as={Link} to="/sign-up" variant="primary" className="rounded-pill fw-semibold px-4 py-2">
                                    Register <i className="bi bi-arrow-right ms-2"></i>
                                </Button>
                            </div>
                        </div>

                        <Row className="mb-4 g-4 position-relative" style={{ zIndex: 10 }}>
                            <Col md={4}>
                                <label className="fw-semibold mb-2">Filter by Category:</label>
                                <Select
                                    options={categoryOptions}
                                    value={selectedCategory}
                                    onChange={(opt) => {
                                        setSelectedCategory(opt);
                                        setCurrentPage(1);
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </Col>
                            <Col md={4}>
                                <label className="fw-semibold mb-2">Sort by Price:</label>
                                <Select
                                    options={priceOptions}
                                    value={priceOrder}
                                    onChange={(opt) => {
                                        setPriceOrder(opt);
                                        setCurrentPage(1);
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </Col>
                            <Col md={4}>
                                <label className="fw-semibold mb-2">Search by Name:</label>
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row className="g-4">
                            {loading ? (
                                <div className="d-flex justify-content-center align-items-center py-5">
                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : paginated.length > 0 ? (
                                paginated.map(product => {
                                    const discount = product.price && product.sales_price
                                        ? Math.round((1 - product.sales_price / product.price) * 100)
                                        : 0;

                                    return (
                                        <Col key={product.product_id} xs={12} sm={6} md={4} lg={3}>
                                            <Card
                                                className="h-100 border-0 shadow-sm rounded-4 overflow-hidden hover-scale transition-all position-relative"
                                                style={{ transition: 'transform 0.25s ease, box-shadow 0.25s ease' }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <div className="position-relative bg-light" style={{ height: 200 }}>
                                                    <Card.Img
                                                        src={product.product_img}
                                                        alt={product.product_name}
                                                        className="object-fit-cover w-100 h-100"
                                                    />
                                                    {discount > 0 && (
                                                        <span
                                                            className="position-absolute top-0 end-0 m-2 px-2 py-1 bg-danger text-white fw-semibold rounded-pill small"
                                                            style={{ fontSize: '0.75rem', letterSpacing: '0.3px' }}
                                                        >
                                                            {discount}% OFF
                                                        </span>
                                                    )}
                                                </div>

                                                <Card.Body className="p-3 d-flex flex-column">
                                                    <Card.Title className="fw-semibold fs-6 mb-1 text-dark line-clamp-2">
                                                        {product.product_name}
                                                    </Card.Title>

                                                    <div className="text-muted small mb-2">
                                                        {[product.capacity, product.color].filter(Boolean).join(" · ")}
                                                    </div>

                                                    <div className="mt-auto">
                                                        <div className="mb-2">
                                                            {product.price && product.sales_price && parseFloat(product.price) > parseFloat(product.sales_price) && (
                                                                <span className="text-muted text-decoration-line-through me-2 small">
                                                                    ${parseFloat(product.price).toFixed(2)}
                                                                </span>
                                                            )}
                                                            <span className="text-primary fw-bold fs-5">
                                                                ${parseFloat(product.sales_price || 0).toFixed(2)}
                                                            </span>
                                                        </div>

                                                        <div className="text-muted small">
                                                            {product.display && <div>{product.display}</div>}
                                                            {product.size_and_weight && <div>{product.size_and_weight}</div>}
                                                        </div>

                                                        <div className="text-success small fw-semibold mt-2">
                                                            <i className="bi bi-check-circle me-1"></i> In Stock
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    );
                                })
                            ) : (
                                <Col>
                                    <p className="text-center text-muted py-5">No products found.</p>
                                </Col>
                            )}
                        </Row>


                        {totalPages > 1 && (
                            <div className="d-flex justify-content-center mt-5">
                                <ul className="pagination-custom list-unstyled d-flex gap-2">
                                    <li>
                                        <Button
                                            variant="outline-secondary"
                                            className="rounded-pill px-3 py-1"
                                            disabled={currentPage === 1}
                                            onClick={() => goToPage(currentPage - 1)}
                                        >
                                            &laquo;
                                        </Button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i + 1}>
                                            <Button
                                                variant={currentPage === i + 1 ? 'primary' : 'outline-primary'}
                                                className={`rounded-pill px-3 py-1 fw-semibold ${currentPage === i + 1 ? 'text-white' : ''}`}
                                                onClick={() => goToPage(i + 1)}
                                            >
                                                {i + 1}
                                            </Button>
                                        </li>
                                    ))}
                                    <li>
                                        <Button
                                            variant="outline-secondary"
                                            className="rounded-pill px-3 py-1"
                                            disabled={currentPage === totalPages}
                                            onClick={() => goToPage(currentPage + 1)}
                                        >
                                            &raquo;
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </Container>
                </section>

                <TestimonialSection />
            </main>
            <Footer />
        </div>
    );
};

export default Product;
